import { render, staticRenderFns } from "./performance_details.vue?vue&type=template&id=e2a1ea0c&scoped=true&"
import script from "./performance_details.vue?vue&type=script&lang=js&"
export * from "./performance_details.vue?vue&type=script&lang=js&"
import style0 from "./performance_details.vue?vue&type=style&index=0&id=e2a1ea0c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a1ea0c",
  null
  
)

export default component.exports